import {
  useEmployeeAppExperienceInstance,
  useEmployeeAppMomentInstance
} from '../../services/retrieval';

export const InstancePreloadSink = ({
  userAccessToken,
  instanceAccessToken
}: {
  userAccessToken: string;
  instanceAccessToken: string;
}) => {
  useEmployeeAppExperienceInstance(userAccessToken, instanceAccessToken);
  return null;
};

export const MomentPreloadSink = ({
  userAccessToken,
  momentInstanceAccessToken
}: {
  userAccessToken: string;
  momentInstanceAccessToken: string;
}) => {
  useEmployeeAppMomentInstance(userAccessToken, momentInstanceAccessToken);
  return null;
};
